module.exports = __webpack_public_path__ + "img/yes-match-g1.3156cde2.png";